import * as React from 'react';
import { SVGProps } from 'react';

export const Home = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.6875 18.5V27.875C5.6875 28.3723 5.88504 28.8492 6.23667 29.2008C6.58831 29.5525 7.06522 29.75 7.5625 29.75H24.4375C24.9348 29.75 25.4117 29.5525 25.7633 29.2008C26.115 28.8492 26.3125 28.3723 26.3125 27.875V18.5"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.9375 16.7864L14.6737 4.04887C14.8479 3.87463 15.0546 3.73641 15.2822 3.64211C15.5098 3.54781 15.7537 3.49927 16 3.49927C16.2463 3.49927 16.4902 3.54781 16.7178 3.64211C16.9454 3.73641 17.1521 3.87463 17.3263 4.04887L30.0625 16.7864"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.625 8.34875V5.375H26.3125V13.0363"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Home;
